@switch (item.kind) {
    @case ('link') {
        <a (click)="linkClick.emit()"
           [routerLink]="item.route.path"
           [attr.target]="item.target ?? null"
           [routerLinkActiveOptions]="{ exact: !!item.exact }"
           routerLinkActive="active-link">
            @if (item.icon) {
                <i class="{{ item.icon }} {{ iconSizeClasses(item.icon) }} icon-spacing"></i>
            }
            {{ item.label }}
            @if (item.badgeIndicator === 'signupFeeUnpaid' && !signUpFeePaid) {
                <i class="pi pi-circle-fill"></i>
            }
        </a>
    }
    @case ('external') {
        @if (item.onClick) {
            <a (click)="externalClick.emit(item)">
                @if (item.icon) {
                    <i class="{{ item.icon }} {{ iconSizeClasses(item.icon) }} icon-spacing"></i>
                }
                {{ item.label }}
            </a>
        } @else {
            <a [href]="item.href" [attr.target]="item.target ?? null">
                @if (item.icon) {
                    <i class="{{ item.icon }} {{ iconSizeClasses(item.icon) }} icon-spacing"></i>
                }
                {{ item.label }}
            </a>
        }
    }
    @case ('divider') {
        <hr class="menu-separator">
    }
    @case ('group') {
        <a (click)="groupToggle.emit(item.collapseKey)"
           [attr.aria-expanded]="!isCollapsed(item.collapseKey)"
           [attr.aria-controls]="item.collapseKey + 'Submenu'"
           class="dropdown-toggle">
            @if (item.icon) {
                <i class="{{ item.icon }} {{ iconSizeClasses(item.icon) }} icon-spacing"></i>
            }
            {{ item.label }}
        </a>
        <ul [ngbCollapse]="isCollapsed(item.collapseKey)"
            [id]="item.collapseKey + 'Submenu'"
            class="collapse list-unstyled">
            @for (child of item.children; track child.label ?? child.kind) {
                <li app-menu-item
                    [item]="child"
                    [signUpFeePaid]="signUpFeePaid"
                    [openGroupKey]="openGroupKey"
                    (linkClick)="linkClick.emit()"
                    (externalClick)="externalClick.emit($event)"
                    (groupToggle)="groupToggle.emit($event)">
                </li>
            }
        </ul>
    }
}
